// src/routes/AppDocu/AppDocuUtils.js
// Common utility functions for AppDocu components

import notify from "devextreme/ui/notify";
import AppDocuServiceCall from './AppDocuServiceCall';
import React from "react";
import { Stack, Typography } from "@mui/material";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export const carBrands = [
  "9ff", "Abarth", "AC", "ACM", "Acura", "Aiways", "Aixam", "Alba Mobility", "Alfa Romeo", "Alpina", "Alpine", "Amphicar", "Angelelli Automobili", "Ariel Motor", "Artega", "Aspark", "Aspid", "Aston Martin", "Audi", "Austin", "Austin-Healey", "Autobianchi", "BAIC", "Bedford", "Bellier", "Bentley", "Bestune", "BMW", "Boldmen", "Bolloré", "Borgward", "Brilliance", "Bristol", "Brute", "Bugatti", "Buick", "BYD", "Cadillac", "Caravans-Wohnm", "Carver", "Casalini", "Caterham", "Cenntro", "Changhe", "Chatenet", "Chery", "Chevrolet", "Chrysler", "Cirelli", "Citroen", "CityEL", "Corvette", "CUPRA", "Dacia", "Daewoo", "DAF", "Daihatsu", "Daimler", "Dallara", "Dangel", "De la Chapelle", "De Tomaso", "Delorean", "Devinci Cars", "DFSK", "Dodge", "Dongfeng", "Donkervoort", "DR Automobiles", "DS Automobiles", "Dutton", "e.GO", "Ebro", "Econelo", "Edran", "Elaris", "Embuggy", "EMC", "Estrima", "Evetta", "EVO", "Farizon", "Ferrari", "FISKER", "Fiat", "Ford", "Forthing", "Foton", "Gac Gonow", "Galloper", "Gappy", "GAZ", "GEM", "GEMBALLA", "Genesis", "Giana", "Gillet", "Giotti Victoria", "GMC", "Goupil", "Great Wall", "Grecav", "GTA", "GWM", "Haima", "Hamann", "Haval", "Hiphi", "Holden", "Honda", "Hongqi", "HUMMER", "Hurtan", "Hyundai", "ICH-X", "Ineos", "Infiniti", "Innocenti", "Invicta", "Iso Rivolta", "Isuzu", "Iveco", "IZH", "JAC", "Jaecoo", "Jaguar", "Jeep", "Jensen", "Karma", "KG Mobility", "Kia", "Koenigsegg", "KTM", "Lada", "Lamborghini", "Lancia", "Land Rover", "LDV", "Leapmotor", "LEVC", "Lexus", "Lifan", "Ligier", "Lincoln", "Linzda", "Livan", "Lorinser", "Lotus", "Lucid", "Lynk & Co", "M-Ero", "Mahindra", "MAN", "Mansory", "Martin", "Martin Motors", "Maserati", "Matra", "Maxus", "Maybach", "Mazda", "McLaren", "Mega", "Melex", "Mercury", "Mercedes-Benz", "MG", "Micro", "Microcar", "Militem", "Minari", "Minauto", "MINI", "Mitsubishi", "Mitsuoka", "Mobilize", "Morgan", "Moskvich", "MP Lafer", "MPM Motors", "NIO", "Nissan", "NSU", "Oldsmobile", "Oldtimer", "Omoda", "Opel", "Ora", "Pagani", "Panther Westwinds", "Peugeot", "PGO", "Piaggio", "Plymouth", "Polestar", "Pontiac", "Porsche", "Proton", "Puch", "RAM", "Regis", "Reliant", "Renault", "Rolls-Royce", "Rover", "Ruf", "Saab", "Santana", "SEAT", "Segway", "Selvo", "Seres", "Sevic", "SGS", "Shelby", "Shuanghuan", "Silence", "Singer", "Skoda", "Skywell", "smart", "SpeedArt", "Sportequipe", "Spyker", "SsangYong", "Stormborn", "StreetScooter", "Studebaker", "Subaru", "Suzuki", "SWM", "Talbot", "Tasso", "Tata", "Tazzari EV", "TECHART", "Tesla", "Togg", "Toyota", "Town Life", "Trabant", "Trailer-Anhänger", "Triumph", "Trucks-Lkw", "TVR", "TYN-e", "UAZ", "Vanden Plas", "Vanderhall", "VAZ", "VEM", "VinFast", "Volkswagen", "Volvo", "Voyah", "Wartburg", "Weltmeister", "Wenckstern", "Westfield", "Wey", "Wiesmann", "XBus", "XEV", "Xiaomi", "Xpeng", "Zastava", "ZAZ", "Zeekr", "Zhidou", "Zotye", "Altro"
];

export const languageOptions = ["ITA", "ENG", "FRA", "SPA", "GER"];

export const comBrandOptions = [  
  { name: 'LANDI', color: '#4d5d78' }, // 
  { name: 'LOVATO', color: '#055ef5' }, // 
  { name: 'AEB', color: '#e64a19' }, // arancione  
];

export const renderComBrandOption = (props, option) => {
  const found = comBrandOptions.find(opt => opt.name === option);
  var color = found ? found.color : '#222';
  return (
    <li {...props} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ display: 'flex', color: color, alignItems: 'center', gap: 8 }}>
        {/* {found && found.color && (
          <span style={{
            display: 'inline-block',
            width: 14,
            height: 14,
            borderRadius: '50%',
            backgroundColor: found.color,
            marginRight: 6,
            border: '1px solid #ccc',
          }}></span>
        )} */}
        {option}
      </span>
    </li>
  );
};

// Define a function to generate ECU Type options as array of objects
export const ecuTypeOptions = [  
  { name: 'AEB3000B', description: 'DIRECT INJECTION', color: '#1976d2' }, // blu
  { name: 'DI60', description: 'DIRECT INJECTION', color: '#1976d2' }, // blu
  { name: 'DI60_NG', description: 'DIRECT INJECTION', color: '#1976d2' },
  { name: 'DI60_NG2', description: 'DIRECT INJECTION', color: '#1976d2' },
  { name: 'DI60_NG2A', description: 'DIRECT INJECTION', color: '#1976d2' },
  { name: 'DI60_NG2B', description: 'DIRECT INJECTION', color: '#1976d2' },
  { name: 'DI108', description: 'DIRECT INJECTION', color: '#1976d2' },
  { name: 'DI108_NG', description: 'DIRECT INJECTION', color: '#1976d2' },
  { name: 'MP32_PLUS', description: 'MODULARE 32', color: '#388e3c' }, // verde
  { name: 'MP48_PLUS', description: 'MODULARE 48', color: '#388e3c' },
  { name: 'EVO_L', description: 'MPI 32, LANDI', color: '#fbc02d' }, // giallo
  { name: 'MP32', description: 'MPI 32, AEB', color: '#fbc02d' },
  { name: 'LovatoE_GO', description: 'MPI 32, LOVATO', color: '#fbc02d' },
  { name: 'LovatoSmartExR2', description: 'MPI 32+, LOVATO', color: '#fbc02d' },
  { name: 'EVO', description: 'MPI 48, LANDI', color: '#e64a19' }, // arancione
  { name: 'EVO_OBD_OM3', description: 'MPI 48 OBD, LANDI', color: '#e64a19' },
  { name: '2001MP', description: 'MPI 48, AEB', color: '#e64a19' },
  { name: '2001MPOBD', description: 'MPI 48 OBD, AEB', color: '#e64a19' },
  { name: 'LovatoSmart', description: 'MPI 48, LOVATO', color: '#e64a19' },
  { name: 'LovatoC_OBD4', description: 'MPI 48 OBD, LOVATO', color: '#e64a19' },
  { name: 'MP8C_OBD', description: 'MPI 8C, LANDI', color: '#7b1fa2' }, // viola
  { name: 'MP6C', description: 'MPI 8C, AEB', color: '#7b1fa2' },
  { name: 'LovatoC_OBD8', description: 'MPI 8C, LOVATO', color: '#7b1fa2' },
];

export const documentTypeOptions = [
  { name: 'installation_sheet', color: 'info.main', label: 'Installation Sheet' },
  { name: 'manual', color: 'success.main', label: 'Manual' },
  { name: 'technical_note', color: 'warning.main', label: 'Technical Note' },
];

export const calibrationStatusOptions = [  
  { name: 'DRAFT', color: '#bdbdbd', comment: 'Bozza: calibrazione non ancora pronta o incompleta' }, // grigio
  { name: 'PENDING', color: '#fbc02d', comment: 'In attesa di validazione' }, // giallo
  { name: 'VALID', color: '#388e3c', comment: 'Valida e pronta all’uso' }, // verde
  { name: 'REJECTED', color: '#e64a19', comment: 'Rifiutata: non conforme' }, // arancione
  { name: 'BROKEN', color: '#d32f2f', comment: 'Non funzionante e non utilizzabile' }, // rosso
  { name: 'WARNING', color: '#ff9800', comment: 'Attenzione: calibrazione da ricontrollare' }, // arancione chiaro
];

export const packetStatusOptions = [  
  { name: 'DRAFT', color: '#bdbdbd', comment: 'Bozza: pacchetto non ancora pronto o incompleto' }, // grigio
  { name: 'VALID', color: '#388e3c', comment: 'Valido e pronto all’uso' }, // verde
  { name: 'WARNING', color: '#ff9800', comment: 'Attenzione: pacchetto da ricontrollare' }, // arancione chiaro
  { name: 'OBSOLETE', color: '#9e9e9e', comment: 'Obsoleto: non più supportato' }, // grigio scuro
];

export const renderCalibrationStatusOption = (props, option) => {
  const found = calibrationStatusOptions.find(opt => opt.name === (option?.name || option));
  if (found) {
    return (
      <li {...props} key={found.name} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ width: 14, height: 14, borderRadius: '50%', background: found.color, display: 'inline-block', border: '1px solid #ccc' }}></span>
          <span>{found.name}</span>
        </span>
        <span style={{ fontSize: '0.85em', color: '#888', marginLeft: 22, marginTop: 0 }}>{found.comment}</span>
      </li>
    );
  } else {
    return (
      <li {...props} style={{ color: '#222' }}>{option}</li>
    );
  }
};

export const renderPacketStatusOption = (props, option) => {
  const found = packetStatusOptions.find(opt => opt.name === (option?.name || option));
  if (found) {
    return (
      <li {...props} key={found.name} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ width: 14, height: 14, borderRadius: '50%', background: found.color, display: 'inline-block', border: '1px solid #ccc' }}></span>
          <span>{found.name}</span>
        </span>
        <span style={{ fontSize: '0.85em', color: '#888', marginLeft: 22, marginTop: 0 }}>{found.comment}</span>
      </li>
    );
  } else {
    return (
      <li {...props} style={{ color: '#222' }}>{option}</li>
    );
  }
};

export const machineStatusOptions = [  
  { name: 'VALID', color: '#388e3c', comment: 'Tutto pronto all’uso' }, // verde
  { name: 'BROKEN', color: '#d32f2f', comment: 'Problemi di funzionamento' }, // rosso
  { name: 'WARNING', color: '#ff9800', comment: 'Da controllare' }, // arancione chiaro
];

export const renderMachineStatusOption = (props, option) => {
  const found = machineStatusOptions.find(opt => opt.name === (option?.name || option));
  if (found) {
    return (
      <li {...props} key={found.name} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ width: 14, height: 14, borderRadius: '50%', background: found.color, display: 'inline-block', border: '1px solid #ccc' }}></span>
          <span>{found.name}</span>
        </span>
        <span style={{ fontSize: '0.85em', color: '#888', marginLeft: 22, marginTop: 0 }}>{found.comment}</span>
      </li>
    );
  } else {
    return (
      <li {...props} style={{ color: '#222' }}>{option}</li>
    );
  }
};

export const serviceActivityStatusOptions = [  
  { name: 'OPEN', color: '#e64a19' }, // arancione
  { name: 'CLOSED', color: '#388e3c' }, // verde
];

export const renderServiceActivityStatusOption = (props, option) => {
  const found = serviceActivityStatusOptions.find(opt => opt.name === (option?.name || option));
  if (found) {
    return (
      <li {...props} key={found.name} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ width: 14, height: 14, borderRadius: '50%', background: found.color, display: 'inline-block', border: '1px solid #ccc' }}></span>
        <span>{found.name}</span>
      </li>
    );
  } else {
    return (
      <li {...props} style={{ color: '#222' }}>{option}</li>
    );
  }
};

// Funzione comune per il rendering delle opzioni ECU Type
export const renderEcuTypeOption = (props, option) => {
  const found = ecuTypeOptions.find(opt => opt.name === option);
  return (
    <li {...props} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {/* {found && found.color && (
          <span style={{
            display: 'inline-block',
            width: 14,
            height: 14,
            borderRadius: '50%',
            backgroundColor: found.color,
            marginRight: 6,
            border: '1px solid #ccc',
          }}></span>
        )} */}
        {option}
      </span>
      {found && found.description && (
        <span style={{ fontSize: 12, color: found.color, marginLeft: 12 }}>{found.description}</span>
      )}
    </li>
  );
};

// Brand options for Autocomplete
export const brandOptions = ["LANDI", "AEB", "LOVATO"];

// Injector options for Autocomplete
export const injectorOptions = [
  "GIRS12 - XXS", 
  "GIRS12 - XS", 
  "GIRS12 - S", 
  "GIRS12 - M", 
  "GIRS12 - L", 
  "GI25 - XS",
  "GI25 - S",
  "GI25 - M",
  "GI25 - L",
];

export const vehicleToString = (id, m) => {
  const displacement = m.displacement ? (Number(m.displacement) / 1000).toFixed(1) : '0.0';
  const cylinders = m.cylinders || '-';
  const power = m.power || '-';
  const engine_code = m.engine_code || '-';
  const desc = `[${displacement} ${cylinders}c ${power}kW ${engine_code}]`;  
  return (
    <Stack direction="row" spacing={1} alignItems="center">  
      <Typography variant="body1" sx={{ fontWeight: 500 }}>{m.brand} {m.model}</Typography>
      <Typography variant="body2" color="text.secondary">{desc}</Typography>
      <Typography variant="body2" color="text.secondary">[ID={id}]</Typography>      
    </Stack>
  )
}

export const vehicleToStringRaw = (id, m) => {
  const displacement = m.displacement ? (Number(m.displacement) / 1000).toFixed(1) : '0.0';
  const cylinders = m.cylinders || '-';
  const power = m.power || '-';
  const engine_code = m.engine_code || '-';
  const desc = `[${displacement} ${cylinders}c ${power}kW ${engine_code}]`;
  return `${m.brand} ${m.model} ${desc} [ID=${id}]`;
}

// funzione per visualizzare un messaggio che poi scompare in automatico
export const notifySomething = (message, type = "success") => {
  notify({
    message: message,
    position: {
      my: 'center top',
      at: 'center top',
    },
  }, type, 3000);
};

export const handleDownloadDocument = (doc) => {
  AppDocuServiceCall.downloadProtectedFile(
    'document/download',
    doc.file_hash,
    doc.file_name || doc.original_filename || 'document',
    notifySomething
  );
};

export const handleDownloadCalibration = (doc) => {
  AppDocuServiceCall.downloadProtectedFile(
    'calibration/download',
    doc.file_hash,
    doc.file_name || doc.original_filename || 'calibration',
    notifySomething
  );
};

// Generic descending comparator, with optional special case for 'motor_id'
export function descendingComparator(a, b, orderBy, motors) {
  if (orderBy === 'motor_id' && motors) {
    const codeA = motors.find(m => m.id === a.motor_id)?.code || '';
    const codeB = motors.find(m => m.id === b.motor_id)?.code || '';
    if (codeB < codeA) return -1;
    if (codeB > codeA) return 1;
    return 0;
  }
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

// Returns a comparator function for sorting
export function getComparator(order, orderBy, motors) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy, motors)
    : (a, b) => -descendingComparator(a, b, orderBy, motors);
}

// SortHelper class for sorting utilities
export class SortHelper {
  constructor(order, orderBy, setOrder, setOrderBy, motors) {
    this.order = order;
    this.orderBy = orderBy;
    this.setOrder = setOrder;
    this.setOrderBy = setOrderBy;
    this.motors = motors;
  }

  handleSort = (property) => {
    const isAsc = this.orderBy === property && this.order === 'asc';
    this.setOrder(isAsc ? 'desc' : 'asc');
    this.setOrderBy(property);
  };

  getComparator = () => {
    return getComparator(this.order, this.orderBy, this.motors);
  };
}

// Funzione di utilità per applicare un filtro su un valore
export function applyGridTableFilter(cellValue, filterValue, operation, isNumber) {
  if (cellValue === undefined || cellValue === null) return false;
  if (filterValue === undefined || filterValue === null || filterValue === "") return true;
  if (isNumber) {
    // solo queste operazioni sono valide per i numeri
    var cellNum = Number(cellValue);
    var filterNum = Number(filterValue);
    switch (operation) {
      case "equal":
        return cellNum === filterNum;
      case "notEqual":
        return cellNum !== filterNum;
      case "greaterThan":
        return cellNum > filterNum;
      case "greaterThanOrEqual":
        return cellNum >= filterNum;
      case "lessThan":
        return cellNum < filterNum;
      case "lessThanOrEqual":
        return cellNum <= filterNum;
      default:
        return false;
    }
  } else {
    // operazioni su stringhe
    var cellStr = String(cellValue).toLowerCase();
    var filterStr = String(filterValue).toLowerCase();
    switch (operation) {
      case "contains":
        return cellStr.includes(filterStr);
      case "notContains":
        return !cellStr.includes(filterStr);
      case "startsWith":
        return cellStr.startsWith(filterStr);
      case "endsWith":
        return cellStr.endsWith(filterStr);
      case "equal":
        return cellStr === filterStr;
      case "notEqual":
        return cellStr !== filterStr;
      default:
        return false;
    }
  }
}

export const renderDocumentTypeOption = (props, option) => {
  const found = documentTypeOptions.find(opt => opt.name === (option?.name || option));
  return (
    <li {...props} key={found?.name || option} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <InsertDriveFileIcon fontSize="small" sx={{ color: found?.color || 'info.main' }} />
      <span>{found?.label || option}</span>
    </li>
  );
};
